import fastdom from 'fastdom';
import { px2vw } from '../utils';

export default function animateSwitcher () {
	const switchContainers = [...document.querySelectorAll('.switch__container')]
		.filter((container) => ![...container.children].some((el) => el.classList.contains('switch__tile')));

	if (!switchContainers.length) return;

	function switchResizeHandler() {
		switchContainers.forEach(container => {
            const activeItem = container.querySelector('.switch__item_active');
            const tile = container.querySelector('.switch__tile');

			if (activeItem && tile) moveTile(tile, activeItem, container);
		});
	}

	window.addEventListener("resize", switchResizeHandler, false);

	switchContainers.forEach(container => {
        const div = document.createElement('div');
        div.classList.add('switch__tile');

		setTimeout(() => {
			const activeItem = container.querySelector('.switch__item_active') || Array.from(container.querySelectorAll('input')).find((item) => item.checked)?.parentNode || container.querySelector('.switch__item:first-child');
			activeItem.classList.remove('switch__item_active');
			activeItem.classList.add('switch__item_active');
			const initWidth = activeItem.getBoundingClientRect().width;
			div.style.width = calcTileWidth(initWidth);
			div.style.transform = `translate(0, -50%)`;
            if (!container.querySelector('.switch__tile')) {
                container.appendChild(div);
            }

			const tile = container.querySelector('.switch__tile');
			moveTile(tile, activeItem, container);
		}, 10);

		container.addEventListener('change', (e) => {
			const tabs = e.currentTarget.querySelectorAll('.switch__item');
			tabs.forEach(tab => tab.classList.remove('switch__item_active'));

			const activeItem = e.target.parentNode;
			activeItem.classList.add('switch__item_active');

			const tile = e.currentTarget.querySelector('.switch__tile');
			moveTile(tile, activeItem, container);
		});
	})
}

function calcTileWidth(px) {
	const value = px + 5;
	return innerWidth > 1440 ? `${value}px` : `${px2vw(value)}vw`;
}

function calcTranslate(baseX, nextX) {
	const value = nextX - baseX - 1;
	return innerWidth > 1440 ? `${value}px` : `${px2vw(value)}vw`;
}

function moveTile(tile, activeItem, container) {
	let newWidth;
	let basePosition;
	let newPosition;
	let rightOffset;
	let leftOffset;
	fastdom.measure(() => {
		const activeItemRect = activeItem.getBoundingClientRect();
		newWidth = activeItemRect.width;
		newPosition = activeItemRect.x;
		const {right, left} = activeItemRect;
		basePosition = container.getBoundingClientRect().x + 1;

		const { right: switcherRight, left: switcherLeft } = container.parentNode.getBoundingClientRect()
		rightOffset = switcherRight - right;
		leftOffset = left - switcherLeft;
	});

	fastdom.mutate(() => {
		tile.style.width = calcTileWidth(newWidth);
		tile.style.transform = `translate(${calcTranslate(basePosition, newPosition)}, -50%)`;

		if (rightOffset < 0) container.parentNode.scrollTo({
			left: container.parentNode.scrollLeft - rightOffset,
			behavior: 'smooth',
		});
		if (leftOffset < 0) container.parentNode.scrollTo({
			left: container.parentNode.scrollLeft + leftOffset,
			behavior: 'smooth',
		});
	});
}
